import { useSelector } from "react-redux";
import React, { useCallback, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { ButtonPresets, renderButton } from "../../components/surveyjs/survey/util.components";
import { SvgAssets } from "../../../../components/icon/assets";
import useThrottledTouchEnd from "../../hooks/use-throtted-touch-end";
import Icon from "../../../../components/icon/icon";
import { useQuery } from "../../../../utils/hooks/use-query";
import { ONBOARDING_PATH, ROOT_PATH } from "../../../../routes/constants";
import { selectCandidateOnboardingForm } from "../../redux/selector";

export const CreateNPAScreen = () => {
  useThrottledTouchEnd();
  const candidateOnboardingForm = useSelector(selectCandidateOnboardingForm);
  const { t,i18n } = useTranslation();
  const query = useQuery();
  const candidateId = query.get("candidateId");
  const lang = query.get("lang");
  const npaNumber = query.get("npaNumber");
  const navigate = useNavigate();

  const nextClickHandler = useCallback(() => {
    query.set("sectionName", 'personalInformation');
    navigate(`${ROOT_PATH}/${ONBOARDING_PATH}/form?${query.toString()}`);
  }, []);
  const backToHome = useCallback(() => {
    query.set("sectionName", 'identificationInformation');
    navigate(`${ROOT_PATH}/${ONBOARDING_PATH}?${query.toString()}`);
  }, []);

  const buttonShare = async () => {
    const npaNumber = candidateOnboardingForm?.npaNumber;
    window.ReactNativeWebView?.postMessage?.(
      `{ "action" : "shareNPANumber", "payload" : "${npaNumber}"}`)
  };
  const translate = useMemo(
    () => ({
      next: t("app.button.next"),
      backToHomepage: t("back_to_homepage"),
    }),
    [i18n.language]
  )
  return (
    <div className="fixed overflow-hidden overscroll-y-none h-screen w-screen flex flex-col">
      <div className="flex flex-1 w-full items-center flex-col justify-center" style={{marginBottom: 150}}>
        <Icon
          svg={SvgAssets.document}
          width={200}
          height={200}
        />
        <div className="text-black-600 font-600">Nomor Pengajuan Agen (NPA) Anda:</div>
        <div
            style={{
              backgroundColor: '#FFE4E6',
              display: 'flex',
              justifyContent: 'space-between',
              margin: 24,
              padding: 16,
              borderRadius: 12,
              alignSelf: 'stretch',
            }}>
            <div style={{placeContent: 'space-between', marginRight: 16}}>
                <div style={{width: 'auto', wordBreak: "break-all"}} className="text-[14px]">{candidateOnboardingForm?.modules.personalData.identificationInformation.questionAnswers.firstNameLocal}</div>
                <div className="font-bold" style={{fontSize: 20}}>{candidateOnboardingForm?.npaNumber}</div>
            </div>
            <div style={{alignContent: 'center'}}>
              <button
              style={{backgroundColor: 'white', borderRadius: 12, padding: 8}}
              onClick={buttonShare}>
              <Icon
                svg={SvgAssets.share}
                width={33}
                height={33}
              />
              </button>
            </div>
        </div>
        <button
          className="font-600 text-[16px]"
          onClick={nextClickHandler}
          style={{
            display: 'flex',
            justifyContent: 'center',
            marginLeft: 24,
            marginRight: 24,
            borderRadius: 12,
            alignSelf: 'stretch',
            borderColor: 'Black',
            borderWidth: 1,
            paddingRight: 16,
            paddingLeft: 16,
            paddingTop: 12,
            paddingBottom: 12,
            marginBottom: 12,
            borderTopColor: '#CCC',
            borderBottomColor: '#CCC',
            borderRightColor: '#CCC',
            borderLeftColor: '#CCC'
          }}>
            {translate.next}
        </button>
        <button
          className="font-600 text-[16px]"
          onClick={backToHome}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginLeft: 24,
            marginRight: 24,
            borderRadius: 12,
            alignSelf: 'center',
          }}>
            {translate.backToHomepage}
        </button>
      </div>
    </div>
  );
}